import { render, staticRenderFns } from "./Abstract1Right.vue?vue&type=template&id=1c5e572a&"
var script = {}
import style0 from "./Abstract1Right.vue?vue&type=style&index=0&id=1c5e572a&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports